import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Row, Tab, Tabs } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { getTeamIdsList, isCC, isNCAA, isNCAAAllSports, routeToSpecificScope, teamFullName, text_truncate } from '../../../../helpers';
import { EMPTY_ARRAY, FILTER_GLOBAL_KEYS, FILTER_KEYS, GLOBAL_FILTER_TEAMS_EMPTY } from '../../../../config/constants';
import { useFiltersDispatch, useFiltersState, useUserState } from '../../../../store/hooks';
import { BasicFilterPropsType } from '../type';
import { GlobalFilterTeamsDivisionType, GlobalFilterTeamType } from '../../../../store/types';

import './styles.scss';

const TeamsMultiSelector = ({ forceScope, close, show, open }: BasicFilterPropsType) => {

  const { pathname } = useLocation();
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const {
    [FILTER_GLOBAL_KEYS.TEAMS]: teams = GLOBAL_FILTER_TEAMS_EMPTY,
    [FILTER_KEYS.TEAM_IDS]: selectedTeam = EMPTY_ARRAY
  } = useFiltersState(specificScope, FILTER_KEYS.TEAM_IDS, FILTER_GLOBAL_KEYS.TEAMS);
  const { changeFilterData } = useFiltersDispatch();
  const user = useUserState();
  const [teamIdsList, setTeamIdsList] = useState({ nfl: [], ncaa: [] });
  const [selectedNewTeam, setSelectedNewTeam] = useState<string[]>(selectedTeam.length === 0 ?
    (isCC(user) ? [...teamIdsList.nfl, ...teamIdsList.ncaa] :
      isNCAA(user) || isNCAAAllSports(user) ? [...teamIdsList.ncaa] : [...teamIdsList.nfl])
    : selectedTeam);
  useEffect(() => {
    if (teams) {
      const allTeamsIds = getTeamIdsList(teams);
      setTeamIdsList(allTeamsIds);
      setSelectedNewTeam(selectedTeam.length === 0 ?
        (isCC(user) ? [...allTeamsIds.nfl, ...allTeamsIds.ncaa] :
          isNCAA(user) || isNCAAAllSports(user) ? [...allTeamsIds.ncaa] : [...allTeamsIds.nfl])
        : selectedTeam);
    }
  }, [teams]);
  const [appliqued, setAppliqued] = useState(false);
  const [league, setLeague] = useState(isNCAA(user) || isNCAAAllSports(user) ? 'ncaa' : 'nfl');
  const isNflAllTeamsSelected = (arr: string[]) => teamIdsList.nfl.every((teamId) => arr.indexOf(teamId) !== -1);
  const isNcaaAllTeamsSelected = (arr: string[]) => teamIdsList.ncaa.every((teamId) => arr.indexOf(teamId) !== -1);
  const [nflAllSelected, setNflAllSelected] = useState(
    selectedTeam.length === 0 || isNflAllTeamsSelected(selectedTeam)
  );
  const [ncaaAllSelected, setNcaaAllSelected] = useState(
    selectedTeam.length === 0 || isNcaaAllTeamsSelected(selectedTeam)
  );

  const nflTeamsChecks: JSX.Element[] = [];
  if (teams && teams.nfl) {
    for (const conference in teams.nfl) {
      teams.nfl[conference].forEach((division: GlobalFilterTeamsDivisionType) => {
        nflTeamsChecks.push(
          <Col xs={3} key={division.name} className={'check-02'}>
            <h3>{division.name}</h3>
            {division.teams.map((team, index) => {
                const isSelected = selectedNewTeam.some((idTeam) => idTeam === team.teamId);
                return (
                  <Col
                    key={team.teamAbbrName + index} className={'check-01 radio label-team-filter'}
                    style={{ textAlign: 'left', padding: '10px 12px' }}
                    onClick={() => {
                      const newSelectNew = isSelected ? selectedNewTeam.filter((idTeam) => idTeam !== team.teamId) : [...selectedNewTeam, team.teamId];
                      setSelectedNewTeam(newSelectNew);
                      if (isNflAllTeamsSelected(newSelectNew)) {
                        setNflAllSelected(true);
                      } else {
                        setNflAllSelected(false);
                      }
                    }}
                  >
                    <div
                      className="styled-checkbox-label-checked"
                      style={{ background: isSelected ? '#007ABA' : undefined, marginRight: '10px' }}
                    />
                    <img alt="gameImg" src={`/assets/images/logos/${team.teamAbbrName}.svg`} height="20" width="20" />
                    {text_truncate(team.teamFullName, 20)}
                  </Col>
                );
              }
            )}
          </Col>
        );
      });
    }
  }

  const ncaaTeamsChecks = [];
  if (teams && teams.ncaa) {
    ncaaTeamsChecks.push(
      <Col xs={12} key={'ncaa-col'} className={'check-02'} style={{ paddingLeft: 0, paddingRight: 0 }}>
        {teams.ncaa.map((team: GlobalFilterTeamType, index: number) => {
          const isSelected = selectedNewTeam.some((idTeam) => idTeam === team.teamId);
          return (
            <Col
              key={team.teamAbbrName + index} className={'check-01 radio label-team-filter'}
              style={{ textAlign: 'left', padding: '10px 12px' }}
              onClick={() => {
                const newSelectNew = isSelected ? selectedNewTeam.filter((idTeam) => idTeam !== team.teamId) : [...selectedNewTeam, team.teamId];
                setSelectedNewTeam(newSelectNew);
                if (isNcaaAllTeamsSelected(newSelectNew)) {
                  setNcaaAllSelected(true);
                } else {
                  setNcaaAllSelected(false);
                }
              }}
            >
              <div
                className="styled-checkbox-label-checked"
                style={{ background: isSelected ? '#007ABA' : undefined, marginRight: '10px' }}
              />
              {/*change to .svg no exists OSU.svg*/}
              <img alt="gameImg" src={`/assets/images/logos/${team.teamAbbrName}.png`} height="20" width="20" />
              {team.teamFullName}
            </Col>
          );
        })}
      </Col>
    );
  }
  const onClose = () => {
    close();
    setSelectedNewTeam(selectedTeam.length === 0 ? [...teamIdsList.nfl, ...teamIdsList.ncaa] : selectedTeam);
    setNflAllSelected(selectedTeam.length === 0 || isNflAllTeamsSelected(selectedTeam));
    setNcaaAllSelected(selectedTeam.length === 0 || isNcaaAllTeamsSelected(selectedTeam));
  };
  const actions = <div className="footer-s" style={isCC(user) ? { position: 'absolute' } : {}}>
    <button className="btn-transparet" onClick={onClose}>Cancel</button>
    <button
      className="btn-blue"
      onClick={() => {
        close();
        changeFilterData(
          isCC(user) ? (selectedNewTeam.length === teamIdsList.ncaa.length + teamIdsList.nfl.length ? [] : selectedNewTeam) :
            (isNCAA(user) || isNCAAAllSports(user) ? (selectedNewTeam.length === teamIdsList.ncaa.length ? [] : selectedNewTeam) :
              (selectedNewTeam.length === teamIdsList.nfl.length ? [] : selectedNewTeam))
          , FILTER_KEYS.TEAM_IDS, forceScope)();
        setAppliqued(true);
      }}
      style={selectedNewTeam.length === 0 ? { opacity: '0.6', pointerEvents: 'none' } : undefined}
    >
      Apply
    </button>
  </div>;
  return (
    <Dropdown className={`${isNCAAAllSports(user)? 'team-selector-dropdown tt-ooi ncaa-menu-scroll' : 'team-selector-dropdown tt-ooi menu-scroll' }`} show={show} onToggle={show ? onClose : open}>
      <Dropdown.Toggle id="dropdown-basic" className="btn-border" onClick={show ? onClose : open}>
        <label className={`color-s+${appliqued ? ' appliqued' : ''}`}>TEAM</label>
        {selectedTeam.length === 0 ?
          'All' :
          selectedTeam.length === 1 ?
            teamFullName(teams, selectedTeam[0]) :
            selectedTeam.length === 2 ?
              teamFullName(teams, selectedTeam[0]) + ' (+1) ' :
              'Multiple (' + selectedTeam.length + ')'}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ position: 'relative' }}>
        <Tabs
          style={{ width: '860px', background: 'white', display: isCC(user) ? undefined : 'none', height: '45px' }}
          activeKey={league} id="uncontrolled-tab-example"
          onSelect={() => setLeague(league === 'nfl' ? 'ncaa' : 'nfl')}
          mountOnEnter unmountOnExit
        >
          <Tab eventKey="nfl" title="NFL">
            <div className="switch-ll" style={{ background: isCC(user) ? '#F4F4F4' : undefined }}>
              Select All
              <input
                type="checkbox" id="id-name--20" name="set-name" className="switch-input"
                checked={nflAllSelected}
                onChange={() => {
                  if (nflAllSelected) {
                    setSelectedNewTeam(selectedNewTeam.filter((teamId) => !teamIdsList.nfl.some((tId) => tId === teamId)));
                    setNflAllSelected(false);
                  } else {
                    setSelectedNewTeam([...selectedNewTeam.filter((teamId) => !teamIdsList.nfl.some((tId) => tId === teamId)), ...teamIdsList.nfl]);
                    setNflAllSelected(true);
                  }
                }}
              />
              <label htmlFor="id-name--20" className="switch-label" />
            </div>
            <div className="dropdown-team-selector sub-menu-scroll" style={isCC(user) ? undefined : { height: 'auto' }}>
              <form>
                <Row style={{ height: '452px' }}>
                  {nflTeamsChecks}
                </Row>
              </form>
              {actions}
            </div>
          </Tab>
          <Tab eventKey="ncaa" title="NCAA">
            <div className="switch-ll" style={{ background: isCC(user) ? '#F4F4F4' : undefined }}>
              Select All
              <input
                type="checkbox" id="id-name--20-switch-ncaa" name="set-name" className="switch-input"
                checked={ncaaAllSelected}
                onChange={() => {
                  if (ncaaAllSelected) {
                    setSelectedNewTeam(selectedNewTeam.filter((teamId) => !teamIdsList.ncaa.some((tId) => tId === teamId)));
                    setNcaaAllSelected(false);
                  } else {
                    setSelectedNewTeam([...selectedNewTeam.filter((teamId) => !teamIdsList.ncaa.some((tId) => tId === teamId)), ...teamIdsList.ncaa]);
                    setNcaaAllSelected(true);
                  }
                }}
              />
              <label htmlFor="id-name--20-switch-ncaa" className="switch-label" />
            </div>
            <div className="dropdown-team-selector sub-menu-scroll" style={isCC(user) ? undefined : { height: 'auto' }}>
              <form><Row>{ncaaTeamsChecks}</Row></form>
              {actions}
            </div>
          </Tab>
        </Tabs>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TeamsMultiSelector;
